import styled from "styled-components"

const Boundary = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: ${(props) => props.theme.boundaryWidth}px;
`

export {Boundary}
